import { Button } from "@mantine/core";
import { useCallback } from "react";
import { primaryColor } from "../../../constants/theme";
import { IconBrandAppleFilled } from "@tabler/icons-react";

export function randomNonce(length = 32) {
  const chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._";
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, (n) => chars[n % chars.length]).join("");
}

export async function sha256Base64Url(input: string) {
  const enc = new TextEncoder().encode(input);
  const hashBuf = await crypto.subtle.digest("SHA-256", enc);
  const bytes = new Uint8Array(hashBuf);
  let str = "";
  bytes.forEach((b) => (str += String.fromCharCode(b)));
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

declare global {
  interface Window {
    AppleID: any;
  }
}

type Props = {
  onIdToken: (idToken: string, nonce?: string) => void; // send to your backend
};

export default function AppleSignInButton({ onIdToken }: Props) {
  const handleClick = useCallback(async () => {
    const nonce = randomNonce();
    const nonceSha = await sha256Base64Url(nonce);

    // Initialize (can be done once globally)
    window.AppleID.auth.init({
      clientId: import.meta.env.VITE_APPLE_SERVICE_ID!,
      scope: "name email",
      redirectURI: import.meta.env.VITE_APPLE_REDIRECT_URI!, // still required by Apple even for popup
      usePopup: true,
            // IMPORTANT: send a nonce so your backend can validate token's nonce claim
      nonce, // Apple will SHA-256 this into the id_token
    });
    
    try {
      const res = await window.AppleID.auth.signIn(); // popup
      const idToken = res?.authorization?.id_token;
      if (!idToken) return;
      console.log('Apple ID token received:', idToken);
      onIdToken(idToken, nonceSha); // Call the callback to handle authentication
    } catch (e) {
      // user cancelled or error
      console.error("Apple sign-in failed", e);
    }
  }, [onIdToken]);
  return (
        <Button onClick={handleClick} color={primaryColor} radius={'lg'} size={'md'} type="submit" leftSection={<IconBrandAppleFilled/>}>Continue with Apple</Button>
  );
}